<template>
  <div class="section">
    <div class="columns is-centered">
      <div
        class="column is-full-mobile is-8-tablet is-5-desktop is-3-widescreen is-3-fullhd"
        style="text-align: center"
      >
        <h1 class="title is-4">Account aktivieren</h1>
        <div v-if="data === true" class="block">
          <b-message type="is-success">
            Sie haben Ihren Account aktiviert, Sie können sich jetzt anmelden.
          </b-message>
          <b-button tag="router-link" :to="{ name: 'Login' }" expanded>
            zum Login
          </b-button>
        </div>
        <div v-else>
          <div v-if="error" class="block">
            <b-message type="is-danger">
              {{ error }}
            </b-message>
          </div>
          <div class="block">
            <ValidationObserver
              ref="observer"
              v-slot="{ handleSubmit, invalid }"
            >
              <div
                v-on:keyup.enter="handleSubmit(submit)"
                style="text-align: left"
              >
                <div class="block">
                  <BInputWithValidation
                    rules="required|min:6"
                    type="password"
                    label="Passwort"
                    v-model="password"
                  />
                </div>

                <div class="block">
                  <BInputWithValidation
                    :rules="`required|is:${password}`"
                    type="password"
                    label="Passwort wiederholen"
                    password-reveal
                  />
                </div>

                <div class="block">
                  <b-button
                    type="is-outlined is-gold"
                    expanded
                    :disabled="invalid"
                    :loading="loading"
                    @click="handleSubmit(submit)"
                  >
                    Aktivieren
                  </b-button>
                </div>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import BInputWithValidation from '@/components/inputs/BInputWithValidation.vue';

export default {
  name: 'PasswordRequest',
  components: {
    BInputWithValidation,
  },
  data() {
    return {
      token: this.$route.query.token || 0,
      password: null,
    };
  },
  methods: {
    submit() {
      this.$store.dispatch('auth/signup/PUSH', { token: this.token, password: this.password });
    },
  },
  computed: {
    ...mapGetters({ data: 'auth/signup/data', error: 'auth/signup/error', loading: 'auth/signup/loading' }),
  },
  mounted() {
    this.$store.commit('auth/signup/SET_DATA_CLEAR');
    this.$store.commit('auth/signup/CLEAR_ERROR');
  },
};
</script>
